import { render, staticRenderFns } from "./ShipperItemPage.vue?vue&type=template&id=561c25ac&scoped=true&"
import script from "./ShipperItemPage.vue?vue&type=script&lang=js&"
export * from "./ShipperItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipperItemPage.vue?vue&type=style&index=0&id=561c25ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c25ac",
  null
  
)

export default component.exports